import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import { DateTime } from 'luxon';
import {
  ACCREDITATION_REJECTION_REASON_CODES,
  getRejectionReasonLabel,
} from '../../accreditation-rejection-reasons';
import {
  AccreditationDetailFormValues,
  isRejectionReasonRequired,
} from '../accreditations-detail.types';
import { RawAccreditationData } from '../../../../../services/accreditations-service.types';

export const useAccreditationDetailModalBody = (data: RawAccreditationData) => {
  const { t } = useTranslation('hq-screen-specific');

  const methods = useForm<AccreditationDetailFormValues>({
    defaultValues: {
      expirationDate: data.expirationDate
        ? DateTime.fromISO(data.expirationDate).toFormat('yyyy-MM-dd')
        : undefined,
      rejectionReason: data.rejectionReason ?? '',
    },
  });

  const rejectionReasonOptions = useMemo(
    () =>
      ACCREDITATION_REJECTION_REASON_CODES.map((code) => ({
        value: code,
        label: getRejectionReasonLabel(t, code),
      })),
    [t]
  );

  const rejectionReasonFieldRules = isRejectionReasonRequired(data.state)
    ? { required: t('certificates.detail.rejection-reason.required') }
    : undefined;

  const handleOpenAccreditation = () => {
    if (data.fileUrl) {
      window.open(data.fileUrl, '_blank');
    }
  };

  return {
    methods,
    rejectionReasonOptions,
    rejectionReasonFieldRules,
    handleOpenAccreditation,
  };
};
